import toString from './to-string';
var upperCase = function (str) {
    return toString(str).toUpperCase();
};
export default upperCase;
//# sourceMappingURL=upper-case.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/upper-case.js
// module id = 532
// module chunks = 3